module.exports = __webpack_public_path__ + "img/easyuni_logo.0e22ec92.png";